import { deleteAuthToken } from './authToken';
import { deleteLogoutToken } from './logoutToken';

export const deleteTokens = (res: TServerSideResponse) => {
  deleteAuthToken(res);
  deleteLogoutToken(res);
};

export * from './authToken';
export * from './logoutToken';
export * from './loginRedirectUrl';
export * from './processTokenSet';
